import { render, staticRenderFns } from "./nav-parte.vue?vue&type=template&id=75fed9ce&scoped=true&"
import script from "./nav-parte.vue?vue&type=script&lang=js&"
export * from "./nav-parte.vue?vue&type=script&lang=js&"
import style0 from "./nav-parte.vue?vue&type=style&index=0&id=75fed9ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fed9ce",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75fed9ce')) {
      api.createRecord('75fed9ce', component.options)
    } else {
      api.reload('75fed9ce', component.options)
    }
    module.hot.accept("./nav-parte.vue?vue&type=template&id=75fed9ce&scoped=true&", function () {
      api.rerender('75fed9ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/nav-parte.vue"
export default component.exports